require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconAddUser.tsx
var IconAddUser_exports = {};
__export(IconAddUser_exports, {
  default: () => IconAddUser_default
});
module.exports = __toCommonJS(IconAddUser_exports);

// src/assets/monochrome/addUser.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgAddUser = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5655 5.27137C10.5655 6.62024 9.49425 7.71371 8.17283 7.71371C6.8514 7.71371 5.78017 6.62024 5.78017 5.27137C5.78017 3.92251 6.8514 2.82904 8.17283 2.82904C9.49425 2.82904 10.5655 3.92251 10.5655 5.27137ZM12.3573 5.27137C12.3573 7.63039 10.4839 9.54275 8.17283 9.54275C5.86179 9.54275 3.98833 7.63039 3.98833 5.27137C3.98833 2.91236 5.86179 1 8.17283 1C10.4839 1 12.3573 2.91236 12.3573 5.27137ZM2.79183 18.0855C2.79183 15.052 5.20091 12.5929 8.17266 12.5929C11.1444 12.5929 13.5535 15.052 13.5535 18.0855C13.5535 18.5906 13.9546 19 14.4494 19C14.9442 19 15.3453 18.5906 15.3453 18.0855C15.3453 14.0419 12.134 10.7639 8.17266 10.7639C4.21131 10.7639 1 14.0419 1 18.0855C1 18.5906 1.40112 19 1.89592 19C2.39072 19 2.79183 18.5906 2.79183 18.0855ZM15.4487 5.38455C15.9435 5.38455 16.3446 5.79399 16.3446 6.29907V8.09457H18.1041C18.5989 8.09457 19 8.50401 19 9.00909C19 9.51416 18.5989 9.92361 18.1041 9.92361H16.3446V11.7186C16.3446 12.2237 15.9435 12.6332 15.4487 12.6332C14.9538 12.6332 14.5527 12.2237 14.5527 11.7186V9.92361H12.7948C12.3 9.92361 11.8988 9.51416 11.8988 9.00909C11.8988 8.50401 12.3 8.09457 12.7948 8.09457H14.5527V6.29907C14.5527 5.79399 14.9538 5.38455 15.4487 5.38455Z", fill: "#818898" }) });
var addUser_default = SvgAddUser;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconAddUser.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconAddUser = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(addUser_default, {}) });
};
IconAddUser.displayName = "IconAddUser";
var IconAddUser_default = IconAddUser;
